export const buildIsKnownHost = <Hosts extends string[]>(knownHosts: Hosts) => {
    return (host: string): host is Hosts[number] => {
        return knownHosts.includes(host);
    };
};

export const buildIsKnownHostEntry = <Hosts extends Record<string, string>, Key extends keyof Hosts>(knownHosts: Hosts) => {
    return (host: unknown): host is Key => {
        return Object.keys(knownHosts).includes(host as string);
    };
};
